import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  labelContainer: {
    fontSize: 16,
  },
  label: {
    fontWeight: 600,
    lineHeight: "1.5 !important",
    fontSize: "inherit",
  },
  "spacing-8": {
    marginBottom: 8,
    "&:not(:first-child)": {
      marginTop: 8,
    },
  },
  "spacing-16": {
    marginBottom: 8,
    "&:not(:first-child)": {
      marginTop: 16,
    },
  },
  "spacing-32": {
    marginBottom: 8,
    "&:not(:first-child)": {
      marginTop: 32,
    },
  },
}));

export default useStyle;
